import React, { useState, useEffect, useContext } from "react"
import { getDateInFormat, getAge } from "../services/helperFunctions"
import { JourneyContext } from "../context/journeyContext"
import {
  getOTP,
  fetchAllJourneyData,
  verifyDeclarationOtp,
  saveApplication,
  flexiEdgeProposalForm,
  verifyDeclarationOtpV2,
  awsImageUrl,
  getCisForm
} from "../../services/apiservice"
import { errorToastr } from "../../services/error-handler"
import { wordCapital } from "../../shared/functions"
import { isIE } from "react-device-detect"
import * as lookup from "../../../static/lookup.json"

export default function Declaration(props) {
  console.log(props);

  const [mobileProceed, setMobileProceed] = useState(false)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [agreeTodeclaration, setAgreeToDeclaration] = useState(true)
  const [agreeToCIS, setAgreeToCIS] = useState(false)
  const [otpEntered, setOtpEntered] = useState(null)
  const [otpEntered2, setOtpEntered2] = useState(null)
  const [otpSent, setOtpSent] = useState(false)
  const [otpSent2, setOtpSent2] = useState(false)
  const [registeredMobileNumber, SetRegisteredMobileNumber] = useState(null)
  const [registeredMobileNumber2, SetRegisteredMobileNumber2] = useState(null)
  const [registeredEmailId, SetRegisteredEmailId] = useState(null)
  const [registeredEmailId2, SetRegisteredEmailId2] = useState(null)
  const [corpEmailId, setCorpEmailId] = useState(null)
  const [showResendOtpButton, setShowResentOtpButton] = useState(false)
  const [showResendOtpButton2, setShowResentOtpButton2] = useState(false)
  const [resetOtpCounter, setResetOtpCounter] = useState(0)
  const [resetOtpCounter2, setResetOtpCounter2] = useState(0)
  const [placeEntered, setPlaceEntered] = useState();
  const [placeError, setPlaceError] = useState("")
  const [corpDiscOpt, setCorpDiscOpt] = useState("N")
  const [corpOtpReceive, setCorpOtpReceive] = useState()
  const [corpDiscountOTPVerified, setCorpDiscountOTPVerified] = useState("N")
  const [isLaAndPropSame, setIsLaAndPropSame] = useState(null)
  const [isLaMinor, setIsLaMinor] = useState(false)
  const [journeyType, setJourneyType] = useState()
  const [journeyData, setJourneyData] = useState()
  const [downloadForm, setDownloadForm] = useState()
  const [readInformation, setReadInformation] = useState(false)
  const [b64Pdf,setB64Pdf] = useState();
  let [showError, setShowError] = useState({
    enableAgree: false,
    place: false,
    otp: false,
  })

  var allJourneyData
  useEffect(() => {
    const fetchData = async () => {
      try {
        const payload = {
          journeyId: journeyState.journeyId,
        }

        const res = await fetchAllJourneyData(payload)

        SetRegisteredMobileNumber(res?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo)
        SetRegisteredMobileNumber2(res?.proposerDetails?.communicationDetails?.contactDetails?.mobileNo)
        SetRegisteredEmailId(res?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId)
        SetRegisteredEmailId2(res?.proposerDetails?.communicationDetails?.contactDetails?.emailId)
        setIsLaAndPropSame(res?.lifeAssuredDetails?.isLaAndPropSame)
        setJourneyType(res?.journeyType)
        setJourneyData(res)
        setCorpDiscOpt(res?.productDetails?.corporateDiscountInd)
        setCorpEmailId(res?.basicDetails?.corpEmailID)

        if (getAge(res?.lifeAssuredDetails?.dob) < 18) {
          setIsLaMinor(true)
        }

        const payload2 = {
          data: res,
          id: journeyState.journeyId,
        }

        await flexiEdgeProposalForm(payload2);

      } catch (error) {
        console.error(error)
      }
    }

    const fetchCisFormLink = async() => {
      try {
        const payload = {
          journeyId: journeyState.journeyId,
        }

        const response = await getCisForm(payload) 
        if (response?.customerInfoSheetLink?.pdfBase64) {
            setB64Pdf(response?.customerInfoSheetLink?.pdfBase64)
            setDownloadForm(response.customerInfoSheetLink.fileName)
        }else {
            console.error('File name not found in response', response);
        }
      }catch(err){
        console.info(err?.message)
      }
    }

    fetchData()
    fetchCisFormLink()
  }, [])

  useEffect(() => {
    const timer = resetOtpCounter > 0 && setInterval(() => setResetOtpCounter(resetOtpCounter - 1), 1000)
    return () => clearInterval(timer)
  }, [resetOtpCounter])

  useEffect(() => {
    const timer2 = resetOtpCounter2 > 0 && setInterval(() => setResetOtpCounter2(resetOtpCounter2 - 1), 1000)
    return () => clearInterval(timer2)
  }, [resetOtpCounter2])

  const onItemClick = async()=>{

    console.log(document)
    console.info('Download Form:', downloadForm);
    const fileName = `${journeyState.applicationNo}/${downloadForm}`;
    setReadInformation(true)
    if(b64Pdf){
      const linkSource = "data:application/pdf;base64," + b64Pdf
      const link = document.createElement("a")
      link.href = linkSource
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      link.remove()

      window.addEventListener(
        "focus",
        function () {
          URL.revokeObjectURL(link.href)
        },
        { once: true }
      )
    }else{
      const res = await awsImageUrl(fileName, journeyState.applicationNo);   

      setB64Pdf(res.data);
      const linkSource = "data:application/pdf;base64," + res.data
      const link = document.createElement("a")
      link.href = linkSource
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      link.remove()

      window.addEventListener(
        "focus",
        function () {
          URL.revokeObjectURL(link.href)
        },
        { once: true }
      )
    }
  }

  const handleAgreeChange = () => {
    setAgreeToDeclaration(prev => !prev)
  }

  const handleAgreeCIS = () => {
    setAgreeToCIS(prev => !prev)
  }

  const handleInputChange = ({ target }) => {
    if (!isNaN(target.value)) {
      setOtpEntered(target.value)
    } else { }
  }
  const handleInputChange2 = ({ target }) => {
    if (!isNaN(target.value)) {
      setOtpEntered2(target.value)
    } else { }
  }
  const handlePlaceChange = ({ target }) => {
    if (target.value) {
      setShowError(prev => {
        return {
          ...prev,
          place: false
        }
      })
      setPlaceEntered(wordCapital(target.value));
      let pattern = /[\<\>\[\]\{\}\^\?]/
      let n = pattern.test(target.value.toString())
      if (n) {
        setPlaceError("Please enter valid place")
        setShowError(prev => {
          return {
            ...prev,
            place: true
          }
        })
      } else {
        setPlaceError("")
        setShowError(prev => {
          return {
            ...prev,
            place: false
          }
        })
      }
    } else {
      setPlaceError("Please enter place")
      setShowError(prev => {
        return {
          ...prev,
          place: true
        }
      })
      setPlaceEntered("")
    }
  }

  const handleEnterAccept = (event) => {
    if (event.key == 'Enter') {
      handleAccept(event)
    }

  }

  const handleAccept = (e) => {
    let verifyOtpCall = true;
    e.preventDefault();
    if (isLaAndPropSame === "N") {
      if (isLaMinor) {
        if (!otpEntered2) {
          errorToastr("Please enter Proposer OTP")
          verifyOtpCall = false
        }
      } else if (!otpEntered2 && !otpEntered) {
        errorToastr("Please enter Proposer & LifeAssured OTP")
        verifyOtpCall = false
      } else if (!otpEntered2) {
        errorToastr("Please enter Proposer OTP")
        verifyOtpCall = false
      } else if (!otpEntered) {
        errorToastr("Please enter LifeAssured OTP")
        verifyOtpCall = false
      }
    } else {
      if (!otpEntered) {
        errorToastr("Please enter LifeAssured OTP")
        verifyOtpCall = false
      }
    }

    if (verifyOtpCall) {

      let otpVerifyPayload
      let toCallFinalSubmission
      //handle send link to customer case
      if(journeyType && journeyType.toLowerCase() === "canarapos" && journeyData?.posDashboardListingDetails?.canaraPosCaseType === "sendLinktosales"){
        toCallFinalSubmission = true
      }else if(journeyType && journeyType.toLowerCase() === "canarapos"){
        toCallFinalSubmission = false
      }else{
        toCallFinalSubmission = true
      }
      if (isLaMinor) {
        otpVerifyPayload = {
          "mobileNo": registeredMobileNumber2,
          "otp": otpEntered2,
          "journeyId": journeyState.journeyId,
          "date": Math.floor((new Date().getTime()) / 1000),
          "place": placeEntered,
          "toCallFinalSubmission": toCallFinalSubmission
        }
      } else if (isLaAndPropSame === "N" && registeredMobileNumber === registeredMobileNumber2) {
        otpVerifyPayload = {
          "mobileNo": registeredMobileNumber,
          "mobileNoProposer": registeredMobileNumber2,
          "otp": otpEntered,
          "otpProposer": otpEntered2,
          "journeyId": journeyState.journeyId,
          "date": Math.floor((new Date().getTime()) / 1000),
          "place": placeEntered,
          "samePropLaNo": true,
          "toCallFinalSubmission": toCallFinalSubmission
        }
      } else {
        otpVerifyPayload = {
          "mobileNo": registeredMobileNumber,
          "mobileNoProposer": registeredMobileNumber2,
          "otp": otpEntered,
          "otpProposer": otpEntered2,
          "journeyId": journeyState.journeyId,
          "date": Math.floor((new Date().getTime()) / 1000),
          "place": placeEntered,
          "toCallFinalSubmission": toCallFinalSubmission
        }
      }
      console.log(otpVerifyPayload);
      if(journeyType && journeyType.toLowerCase() === "canarapos"){
        verifyDeclarationOtpV2(otpVerifyPayload).then(res => {
          if (res?.data?.status) {
            setMobileProceed(true)
            console.log(res)
            let sendPayload = {
              applicationData: journeyState.journeyData,
              journeyData: {
                _id: journeyState.journeyId,
                lastPage: props.currentPageIndex,
                lastSection: props.currentSectionIndex + 1,
                applicationNo: journeyState.applicationNo,
                illustrationNumber: journeyState.illustrationNumber,
                proposalEntryId: journeyState.proposalEntryId,
                lastPageCode: props.pageId,
                planOption: journeyState.planOption,
                lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
                corpDiscountOTPVerified: corpDiscountOTPVerified,
              },
            }
            setJourneyState(prev => {
              return {
                ...prev,
                proposalFormLink: res?.data?.proposalFormLink,
              }
            })
            saveApplication(sendPayload).then(res => {
              props.setCurrentSectionIndex(prev => prev + 1)
            }).catch(err => {
              console.log(err, "err in saveApplication declaration")
            })
          } else {
            errorToastr("Please enter correct OTP")
          }
  
        }).catch(err => {
          console.log(err, "Please enter correct OTP")
        })
      }else{
        verifyDeclarationOtp(otpVerifyPayload).then(res => {
          if (res?.data?.status) {
            setMobileProceed(true)
            console.log(res)
            let sendPayload = {
              applicationData: journeyState.journeyData,
              journeyData: {
                _id: journeyState.journeyId,
                lastPage: props.currentPageIndex,
                lastSection: props.currentSectionIndex + 1,
                applicationNo: journeyState.applicationNo,
                illustrationNumber: journeyState.illustrationNumber,
                proposalEntryId: journeyState.proposalEntryId,
                lastPageCode: props.pageId,
                planOption: journeyState.planOption,
                lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
                corpDiscountOTPVerified: corpDiscountOTPVerified,
              },
            }
            setJourneyState(prev => {
              return {
                ...prev,
                proposalFormLink: res?.data?.proposalFormLink,
              }
            })
            saveApplication(sendPayload).then(res => {
              props.setCurrentSectionIndex(prev => prev + 1)
            }).catch(err => {
              console.log(err, "err in saveApplication declaration")
            })
          } else {
            errorToastr("Please enter correct OTP")
          }
  
        }).catch(err => {
          console.log(err, "Please enter correct OTP")
        })
      }
    }

  }


  const handleEnter = (event) => {
    if (event.key == 'Enter') {
      generateOtp(event)
    }
  }

  const handleEnter2 = (event) => {
    if (event.key == 'Enter') {
      generateOtp2(event)
    }
  }

  const handleMobileProceed = (e) => {
    setMobileProceed(true)
  }

  const generateOtp = (e) => {
    console.log(agreeTodeclaration + "------" + placeEntered);
    e.preventDefault();
    if(lookup.journeyIdsforCIScheck.includes(journeyState.journeyIdFromStrapi) && !readInformation){
      errorToastr("Please download customer information sheet and go through")
      return;
    } else if(lookup.journeyIdsforCIScheck.includes(journeyState.journeyIdFromStrapi) && !agreeToCIS){
      errorToastr("Click on the checkbox to confirm")
      return;
    }
    if (agreeTodeclaration) {
      setShowError(prev => {
        return {
          ...prev,
          enableAgree: false
        }
      })
    } else {
      setShowError(prev => {
        return {
          ...prev,
          enableAgree: true
        }
      })
    }
    if (placeEntered) {
      if (placeError) {
        setShowError(prev => {
          return {
            ...prev,
            place: true
          }
        })
      } else {
        setShowError(prev => {
          return {
            ...prev,
            place: false
          }
        })
      }
    } else {
      setShowError(prev => {
        return {
          ...prev,
          place: true
        }
      })
    }
    if (registeredMobileNumber && placeEntered && !placeError) {
      let payloadForOtp
      if (!corpOtpReceive && corpDiscOpt === "Y") {
        payloadForOtp = {
          mobileNumber: `${registeredMobileNumber}`,
          module: "OTPSMSEMAIL",
          journeyId: journeyState.journeyId,
          emailID: `${corpEmailId}`,
          sendOtpOnMessagee: false,
          date: Math.floor((new Date().getTime()) / 1000),
          place: `${placeEntered}`,
          pageType: "declaration"
        }
      } else {
        payloadForOtp = {
          mobileNumber: registeredMobileNumber,
          module: "OTPSMSEMAIL",
          journeyId: journeyState.journeyId,
          emailID: registeredEmailId,
          "date": Math.floor((new Date().getTime()) / 1000),
          "place": placeEntered,
          sendOtpOnMessagee: true,
          // otpFor: "la"
          pageType: "declaration"
        }
      }
      setShowResentOtpButton(false)
      getOTP(payloadForOtp).then(res => {
        setOtpSent(true)
        console.log(res)
        setResetOtpCounter(30)
        setTimeout(() => {
          setShowResentOtpButton(true)
        }, 30000)
      })
    }
  }

  const generateOtp2 = (e) => {
    console.log(agreeTodeclaration + "------" + placeEntered);
    e.preventDefault();
    if(lookup.journeyIdsforCIScheck.includes(journeyState.journeyIdFromStrapi) && !readInformation){
      errorToastr("Please download customer information sheet and go through")
      return;
    } else if(lookup.journeyIdsforCIScheck.includes(journeyState.journeyIdFromStrapi) && !agreeToCIS){
      errorToastr("Click on the checkbox to confirm")
      return;
    }
    if (agreeTodeclaration) {
      setShowError(prev => {
        return {
          ...prev,
          enableAgree: false
        }
      })
    } else {
      setShowError(prev => {
        return {
          ...prev,
          enableAgree: true
        }
      })
    }
    if (placeEntered) {
      setShowError(prev => {
        return {
          ...prev,
          place: false
        }
      })
    } else {
      setShowError(prev => {
        return {
          ...prev,
          place: true
        }
      })
    }
    if (registeredMobileNumber2 && placeEntered && !placeError) {
      let payloadForOtp
      if(!corpOtpReceive && corpDiscOpt === "Y"){
        payloadForOtp = {
          mobileNumber: `${registeredMobileNumber2}`,
          module: "OTPSMSEMAIL",
          journeyId: journeyState.journeyId,
          emailID: `${corpEmailId}`,
          sendOtpOnMessagee : false,
          date: Math.floor((new Date().getTime()) / 1000),
          place: `${placeEntered}`,
          pageType : "declaration"
        }
      } else {
        if (isLaAndPropSame === "N" && registeredMobileNumber === registeredMobileNumber2 && !isLaMinor) {
          payloadForOtp = {
            mobileNumber: registeredMobileNumber2,
            module: "OTPSMSEMAIL",
            journeyId: journeyState.journeyId,
            samePropLaNo: true,
            emailID: registeredEmailId2,
            sendOtpOnMessagee : true,
            // otpFor: "proposer"
            pageType : "declaration"
          }
        } else {
          payloadForOtp = {
            mobileNumber: registeredMobileNumber2,
            module: "OTPSMSEMAIL",
            journeyId: journeyState.journeyId,
            emailID: registeredEmailId2,
            sendOtpOnMessagee : true,
            // otpFor: "proposer"
            pageType : "declaration"
          }
        }
      }
      setShowResentOtpButton2(false)
      getOTP(payloadForOtp).then(res => {
        setOtpSent2(true)
        console.log(res)
        setResetOtpCounter2(30)
        setTimeout(() => {
          setShowResentOtpButton2(true)
        }, 30000)
      })
    }
  }


  const generateOtpCorpDiscount = () => {
    console.log(agreeTodeclaration+"------"+placeEntered);
    if(lookup.journeyIdsforCIScheck.includes(journeyState.journeyIdFromStrapi) && !readInformation){
      errorToastr("Please download customer information sheet and go through")
      return;
    } else if(lookup.journeyIdsforCIScheck.includes(journeyState.journeyIdFromStrapi) && !agreeToCIS){
      errorToastr("Click on the checkbox to confirm")
      return;
    }
    if(agreeTodeclaration){
      setShowError(prev=>{
        return {
          ...prev,
          enableAgree:false
        }
      })
    }else{
      setShowError(prev=>{
        return {
          ...prev,
          enableAgree:true
        }
      })
    }
    if(placeEntered){
      if(placeError){
        setShowError(prev=>{
          return {
            ...prev,
            place:true
          }
        })
      }else{
        setShowError(prev=>{
          return {
            ...prev,
            place:false
          }
        })
      }
    }else{
      setShowError(prev=>{
        return {
          ...prev,
          place:true
        }
      })
    }
    if(registeredMobileNumber && placeEntered && !placeError){
      let payloadForOtp
        payloadForOtp = {
          mobileNumber: `${registeredMobileNumber}`,
          module: "OTPSMSEMAIL",
          journeyId: journeyState.journeyId,
          emailID: `${registeredEmailId}`,
          sendOtpOnMessagee : true,
          pageType : "declaration"
        }
      setShowResentOtpButton(false)
      getOTP(payloadForOtp).then(res => {
        setOtpSent(true)
        console.log(res)
        setResetOtpCounter(30)
        setTimeout(() => {
          setShowResentOtpButton(true)
        }, 30000)
      })
    }
    let eventName = ""
    let formControlKey = "generateOtp"
    // getAllJourneyData(event, formControlKey)
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, eventName, props.sections?.[props.currentSectionIndex]?.sectionId,formControlKey)
  }

  const handleCorporateOtp = ({ target }) => {
    console.log(target.value);
    if (target.value === "Yes") {
      setCorpOtpReceive(true)
      setCorpDiscountOTPVerified("Y")
    } else if (target.value === "No") {
      setCorpOtpReceive(false)
      generateOtpCorpDiscount()
      setCorpDiscountOTPVerified("N")
    }
  }

  return (
    <>
      <style>{

        `
          @media (max-width:767px){
            .mobile-otp-icon{
              margin-bottom:15px !important;
              display: flex !important;
              justify-content: space-around !important;
            }
            .otp-mobile-view-structure {
              padding:10px 20px !important;
              bottom:40px !important;
            }
            .form-group-PRO{
              margin-bottom:25px !important;
            }
            .form-group-LA{
              margin-bottom:25px !important;
            }
            .otp-mobile-view-structure .sent-otp{
              margin-top:-20px !important;
            }
            .pd-mobile-space-structure {
              padding: 6px 0px;
              padding-bottom: 6px;
            }
            .sent-otp {
              padding: 6px 0 !important;
              font-size: 10px !important;
            }
            ${otpSent2 ? `.white1 {
              padding-bottom: 5px !important;
            }` : ""}
          }

          @media (max-width:280px){
            .white1 {
              font-size: 14px !important;
              padding: 3px 19px !important;
            }
          }
        `
      }
      </style>
      <form
        autoComplete="off"
        id="calculatePremium"
        name="calculatePremium"
        action=""
      >
        <div className="landing-page1-design">
          <div className="container">
            <div className="iselect-box-design">
              <div className="heading-design">
                <div className="iselect-padding left-side-head ckyc-w">
                  <h1 className="iselect-heading">
                    Declaration and Authorization
                  </h1>
                </div>
                <div className="app-quatation mt">
                  <div className="application-design-number hidden-desktop-screen">
                    Application Number: {journeyState.applicationNo}
                  </div>
                </div>
              </div>
              <div className="iselect-padding">
                <div className="new-declaration-scroll-structure-design">
                  <div className="new-declaration-scroll-structure">
                    <p>
                      I further understand that the information provided by me
                      in the proposal form, other documents, questionnaire(s)
                      and medical tests will form the basis of the insurance
                      policy, and the policy will come into force only after
                      receipt of the premium and the communication of acceptance
                      of risk by the Company as per it's Board approved
                      underwriting policy. I agree that in case of fraud and
                      misrepresentation the contract shall be treated in
                      accordance with the Sec 45 of Insurance Act 1938 as
                      amended from time to time.
                    </p>
                    <p>
                      I hereby authorize Canara HSBC Life Insurance Co. Ltd.
                      to send me any information relating to my proposals /
                      policies through SMS on the phone number provided by me or
                      through any other mode.
                    </p>
                    <p>
                      I authorize the Company to seek/or store or/and to share
                      (within or outside India) my personal/sensitive personal
                      information (including information concerning the
                      financial, physical or mental health together with leave
                      records and employment details of the life to be
                      assured/proposer) from/ with (i) Government and/or
                      Regulatory Authority, (ii) Insurance Repositories (iii)
                      CERSAI/UIDAI (iv) reinsurers/group companies/hospitals or
                      diagnostic centers/other insurance companies/third parties
                      including any past or present employer for underwriting
                      assessment, claims investigation/ settlement, e-KYC or KYC
                      authentication (if permitted), offline verification, and
                      policy servicing process. In case of Aadhaar submitted
                      voluntary as KYC, the record retention and usage will be
                      per applicable regulations and KYC authentication/Offline
                      verification shall be for the the purpose of issuance of
                      insurance policy/servicing. I authorize the Company to
                      conduct screening/confirmation/reconfirmation of overall
                      status of my as well as that of the Life to be Assured
                      including the health status through medical examinations,
                      if required, which may include Laboratory tests, Cardiac,
                      Radiological investigations and other medical tests
                      including blood tests to detect bacterial/viral/fungal
                      infections. I hereby give my consent to undergo HIV1/2
                      test by ELISA method. I am aware that this test is only
                      for screening purpose and not confirmatory for HIV/AIDS. I
                      give my consent to receive the information from Central
                      KYC Registry or other statutory authority through
                      SMS/email on the registered number/email address. I
                      declare the details furnished above are true and correct
                      to the best of my knowledge and belief and I understand
                      that I am responsible to inform the company of any change
                      in details mentioned in Section 'A- Personal Details'.
                    </p>
                    <p>
                      I declare that the premium paid/payable are/will be not
                      generated from the precedes of any illegal means/criminal
                      activities/offences and I shall abide by and conform to
                      the Preventation of Money Laundering Act, 2002 or any
                      other applicable laws, I agree and declare that I will
                      notify the Company of any change in the occupation,
                      residential/financial position, status of other Life
                      insurance policy, general health of the Life to be Assured
                      or in any of the statements made in the proposal form
                      subsequent to submissions of this proposal to the Company
                      but before the commencement of risk or issurance of policy
                      whichever is earlier. I confirm that all that all
                      information/documents sent by me either by post or through
                      email ID mentioned in this form for the issurance of the
                      insurance contract. I understand that in case of
                      withdrawal of this application by me post undergoing
                      medicals or part thereof, the Company shall return the
                      premium deposit after deducing the expenses incurred on
                      the medical test/examination, if any.
                    </p>
                    <h2 className="head-dec">
                      Foreign Account Tax Compliance Act ("FATCA")/Common
                      Reporting Standards("CRS") Declaration:
                    </h2>
                    <span>
                      (Applicable if the proposer is a US person or is a tax
                      resident outside of India):
                    </span>
                    <ul className="list-dec">
                      <li>
                        I certify that (a) I am taxable as US person under the
                        laws of the United States of America ("U.S") or any
                        state or political subdivision thereof or therein,
                        including the District of Columbia or any states of the
                        U,S., or (b) an estate the income of which is subject to
                        U.S federal income tax regardless of the source
                        thereof.(This clause is applicable only if the proposer
                        is identified as a US person): or (c) taxable as a tax
                        under the laws of country outside India.{" "}
                      </li>
                      <li>
                        I understand that the Company is relying on the
                        information submitted by me for the purpose of
                        determining my status in compliance FATCA/CRS. The
                        Company is not able to offer any tax advice on CRS OR
                        FATCA ot its impact on me. I shall seek advice from
                        professional tax advisor for any tax questions. I agree
                        to Sumit a new form within 30 days if any information or
                        certification on this form becomes incorrect. I agree
                        that as may be required by domestic regulators/tax
                        authorities , the Company may also be required to
                        repost, reportable details to CBDT or close or suspend
                        my policy. I certify that I provide the information on
                        this form and to the best of my knowledge and belief the
                        certification is true, correct, and complete including
                        the taxpayer identification number.{" "}
                      </li>
                    </ul>
                    <div className="mg-low">
                      <h2 className="head-dec">
                        Section 41 of Insurance Act, 1938 (as amended from time
                        to time):
                      </h2>
                      <ul className="list-dec">
                        <li>
                          No person shall allow or offer to allow, either
                          directly or indirectly, as an inducement to any person
                          to take out or renew or continue an insurance in
                          respect of any kind of risk relating to lives or
                          property in India, any rebate of the whole or part of
                          the commission payable or any rebate of the premium
                          shown on the policy, nor shall any person taking out
                          or renewing or continuing a policy accept any Provided
                          that acceptance by an insurance agent of commission in
                          connection with a policy of life insurance taken out
                          by himself on his own life shall not be deemed to be
                          acceptance of a rebate of premium within the meaning
                          of the sub section if at the time of such acceptance
                          the insurance agent satisfies the prescribed
                          conditions establishing that he is a benefit insurance
                          agent employed by the insurer.{" "}
                        </li>
                        <li>
                          Any person making default in complying with the
                          provision of this provisions of this section shall be
                          liable for a penalty which may extend to ten lakh
                          rupees.{" "}
                        </li>
                      </ul>
                    </div>
                    <div className="mg-low">
                      <h2 className="head-dec">
                        Section 45 of Insurance Act, 1938 (as amended from time
                        to time)
                      </h2>
                      <ul className="list-dec">
                        <li>
                          {" "}
                          No policy of life insurance shall be called in
                          question an any ground whatsoever after the expiry of
                          three years from the date of the policy, i.e., from
                          the date of issuance of the policy or the date of
                          commencement of risk or the date of revival of the
                          policy or the date of the rider to the policy,
                          whichever is later.
                        </li>
                        <li>
                          A policy of life insurance may be called in question
                          at any time within three years from the date of
                          issuance of the policy or the date of commencement of
                          risk or the date of revival of the policy or the date
                          of the rider to the policy, whichever is later, on the
                          ground of fraud: Provided that the insurer shall have
                          to communicate in writing to the insured or the legal
                          representatives or nominees or assignees of the
                          insured the grounds and materials on which such
                          decision is based.{" "}
                        </li>
                        <li>
                          Notwithstanding anything contained in sub-section (2),
                          no insurer shall repudiate a life insurance policy on
                          the ground of fraud if the insured can prove that the
                          mis-statement of a or suppression of a material fact
                          was true to the best of his knowledge and belief or
                          that there was no deliberate intention to suppress the
                          fact or that such mis-statement of or suppression of a
                          material fact are within the knowledge of the insurer:
                          Provided that in case of fraud, the onus of disproving
                          lies upon the beneficiaries, in case the policyholder
                          is not alive.{" "}
                        </li>
                        <li>
                          "A policy of life insurance may be called in question
                          at any time within three years from the date of
                          issuance of the policy or the date of commencement of
                          risk or the date of revival of the policy or the date
                          of the revival of the policy, whichever is later, on
                          the ground that any statement of or suppression of a
                          fact material to the expectancy of the life of the
                          insured was incorrectly made in the proposal or other
                          document on the basis of which the policy was issued
                          or revived or rider issued: Provided that the insurer
                          shall have to communicate in writing to the insured or
                          the legal representatives or nominees or assignees of
                          the insured the grounds and materials on which such
                          decision to repudiate the policy of life insurance is
                          based: Provided further that in case of repudiation of
                          the policy on the ground of misstatement or
                          suppression of a material fact, and not on ground of
                          fraud, the premiums collected on the policy till the
                          date of repudiation shall be paid to the insured or
                          the legal representatives or nominees or assignees of
                          the insured within a period of ninety days from the
                          date of such repudiation. "{" "}
                        </li>
                        <li>
                          Nothing in this section shall prevent the insurer from
                          calling for proof of age at any time if he is entitled
                          to do so, and no policy shall be deemed to be called
                          in question merely because the terms of the policy are
                          adjusted on subsequent proof that the age of the life
                          insured was incorrectly stated in the proposal.{" "}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="mg-bottom pd40">
                  <div className="col-md-12 col-xs-12 pl">
                    <div className="transactionDetailsWrap del-agree">
                      <div className="detailContentWrap">
                        <div className="row iAgree">
                          <div className="form-group">
                            <div className="inner-addon left-addon">
                              <div className="checkbox1">
                                <input
                                  name="checkboxG6"
                                  id="checkboxG6"
                                  className="css-checkbox"
                                  type="checkbox"
                                  onChange={handleAgreeChange}
                                  checked={agreeTodeclaration}
                                />
                                <label
                                  htmlFor="checkboxG6"
                                  className="css-label"
                                >
                                  {" "}
                                  I agree to the Declaration and Authorization
                                  as mentioned above.
                                </label>
                              </div>
                              {showError && showError.enableAgree ? (<div style={{ color: "red" }}>*This field is required</div>) : (<div></div>)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {lookup.journeyIdsforCIScheck.includes(journeyState.journeyIdFromStrapi) && 
                <div>
                <p style={{
                  color : "#0d6efd",
                  marginBottom : "0px",
                  cursor :"pointer"
                }} aria-hidden="true" onClick={onItemClick}>
                    <div className="link-tag">
                      Click here to download Customer Information sheet
                    </div>
                  </p>
                  <div className="col-md-12 col-xs-12 pl">
                    <div className="transactionDetailsWrap del-agree">
                      <div className="detailContentWrap">
                        <div className="row iAgree">
                          <div className="form-group">
                            <div className="inner-addon left-addon">
                              <div className="checkbox1">
                                <input
                                  name="checkboxG7"
                                  id="checkboxG7"
                                  className="css-checkbox"
                                  type="checkbox"
                                  onChange={handleAgreeCIS}
                                  checked={agreeToCIS}
                                />
                                <label
                                  htmlFor="checkboxG7"
                                  className="css-label"
                                >
                                  {" "}
                                  I have read the customer information sheet and confirm having noted the details.
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
                <div className="date-and-place-structure hidden-desktop-screen row" style={{
                  alignItems : "center",
                  marginBottom : "20px"
                }}>
                  <div className="col-md-4" style={{ top: "18px" }} >
                    <p style={{
                      marginBottom : "0px",
                      marginLeft : "10px"
                    }}>
                      <span>Date: </span>{getDateInFormat(Math.floor((new Date().getTime()) / 1000))}
                    </p>
                  </div>
                  <div className="col-md-6" style={{ top: "-40px" }} >
                    
                     
                      {/* <span>Place:</span>  */}
                      <div className="iselect-mg-bottom-1 enter-otp-structure hidden-desktop-screen">
                        <div className="col-md-6 col-xs-12 all-box-padding-right">
                          <div className="form-group">
                            <label className="title-bg inp-label" style={{
                              marginTop :'0px'
                            }}>Place</label>
                            <input className="form-control" name={+Date.now()}
                              style={isIE ? { lineHeight: 1 } : {}}
                              type="text" placeholder="Enter place" value={placeEntered} autoComplete="new-password" onChange={handlePlaceChange} />
                            {showError && showError.place ? (<span style={{ color: "red" }} className="input-error remove-font-weight" >{placeError}</span>) : (<div></div>)}
                          </div>
                        </div>
                      </div>
                    
                  </div>
                </div>
                <div className="clearfix"></div>
                {isLaAndPropSame === "N" &&
                  <div className="generate-otp-structure hidden-desktop-screen" style={{ marginTop: "0" }} >
                    <div className="previous-btn cen button" tabIndex="0" onKeyPress={(event) => { handleEnter2(event) }} style={{
                      transition: "none",
                      padding: "0",
                      backgroundColor: `${agreeTodeclaration ? (journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25") : "grey"}`
                    }}>  {/*var(--lumiq-tertiary);*/}
                      {!otpSent2 &&
                        <button className="white1" aria-hidden="true" onClick={generateOtp2} style={{ border: "none", color: "white", borderRadius: "1rem", outline: "none", width: "auto", fontSize: "16px", padding: "6px 40px", backgroundColor: `${agreeTodeclaration ? (journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25") : "grey"}` }} disabled={!agreeTodeclaration}> {/* var(--lumiq-tertiary); */}
                          Generate OTP
                        </button>
                      }
                    </div>
                    <div style={ corpDiscOpt === "Y" ? { display: "flex", justifyContent: "center" } : undefined } >
                      {otpSent2 && (
                        <p className="sent-otp">
                          OTP has been sent to your registered{" "}
                          {corpDiscOpt === "Y" ? "Corporate Email Id" : "mobile number and email id"}
                        </p>
                      )}
                    </div>
                  </div>}
                <div className="clearfix"></div>
                {isLaAndPropSame === "N" &&
                  <div className="iselect-mg-bottom mt-30 enter-otp-structure hidden-desktop-screen" style={{ "paddingBottom": "20px" }}>
                    <div className="col-md-6 col-xs-12 all-box-padding-right">
                      <div className="form-group">
                        <label className="title-bg inp-label">Enter OTP TO PROPOSER</label>
                        <input
                          className="form-control"
                          style={isIE ? { lineHeight: 1 } : {}}
                          name="otp"
                          type="text"
                          autoComplete="new-password"
                          placeholder="XXXXXX"
                          onChange={handleInputChange2}
                          maxLength={6}
                          value={otpEntered2}
                        />
                        {showResendOtpButton2 ?
                          <div className="resend-otp">
                            <a tabIndex="0" onKeyPress={(event) => { handleEnter2(event) }} onClick={generateOtp2}>RESEND OTP</a>{" "}
                            <span className="fa fa-angle-right"></span>
                          </div>
                          : (otpSent2 &&
                            <div className="resend-otp">
                              <span className="fa">RESEND OTP In {resetOtpCounter2} seconds</span>
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>}


                <div className="clearfix"></div>
                {!isLaMinor &&
                  <div className="generate-otp-structure hidden-desktop-screen" style={{ marginTop: "0" }} >
                    <div className="previous-btn cen button" tabIndex="0" onKeyPress={(event) => { handleEnter(event) }} style={{
                      transition: "none",
                      padding: "0",
                      backgroundColor: `${agreeTodeclaration ? (journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25") : "grey"}`
                    }}>  {/*var(--lumiq-tertiary);*/}
                      {!otpSent &&
                        <button className="white1" onClick={generateOtp} style={{ border: "none", color: "white", borderRadius: "1rem", outline: "none", width: "auto", fontSize: "16px", padding: "6px 40px", backgroundColor: `${agreeTodeclaration ? (journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25") : "grey"}` }} disabled={!agreeTodeclaration}> {/* var(--lumiq-tertiary); */}
                          Generate OTP
                        </button>
                      }
                    </div>

                    {otpSent && (
                        <p className="sent-otp">
                          OTP has been sent to your registered{" "}
                          {corpDiscOpt === "Y" ? "Corporate Email Id" : "mobile number and email id"}
                        </p>
                      )}
                    {/* {otpSent &&
                      <p className="sent-otp">
                        {" "}
                        OTP has been sent to your registered mobile number and email id
                      </p>
                    } */}
                  </div>}

                <div className="clearfix"></div>
                {otpSent && corpDiscOpt === "Y" &&
                <div style={{ display:"flex",justifyContent:"center"}}>
                  <p className="sent-otp">
                    OTP received on your Corporate Email Id
                  </p>
                </div>
                }
                <div className="clearfix"></div>

                {otpSent && corpDiscOpt === "Y" &&

                <div className="sent-otp" style={{ display:"flex",justifyContent:"center", float:"none"}}>
                  <div className="radio-line radio-design sa11">
                    <label className="customradio">
                      <span className="radiotextsty">
                        Yes
                      </span>
                      <input
                        type="radio"
                        name="corporateOtpReceived"
                        value="Yes"
                        onChange={handleCorporateOtp}
                        disabled={corpOtpReceive === false ? true : false }
                      />
                      <span className="provider checkmark" tabIndex="0" ></span>{" "}
                    </label>
                  </div>
                <div className="radio-line radio-design sa11">
                  <label className="customradio">
                    <span className="radiotextsty">
                      No
                    </span>
                    <input
                      type="radio"
                      name="corporateOtpReceived"
                      value="No"
                      onChange={handleCorporateOtp}
                    />
                    <span className="provider checkmark" tabIndex="0" ></span>{" "}
                  </label>
                </div>
                    {/* <input type="radio" value="Yes" name="corporateOtpReceived" onChange={handleCorporateOtp} disabled={corpOtpReceive === false ? true : false } /> Yes
                    <input type="radio" value="No" name="corporateOtpReceived" onChange={handleCorporateOtp} /> No */}
                 </div>
                 }
                <div className="clearfix"></div>

                {otpSent && corpDiscOpt === "Y" && corpOtpReceive === false &&
                <div style={{ display:"flex",justifyContent:"center"}}>
                  <p className="sent-otp">
                    Another OTP has been shared on your personal Email Id and Mobile number
                  </p>
                </div>
                }



                <div className="clearfix"></div>
                {!isLaMinor && corpOtpReceive === true &&
                  <div className="iselect-mg-bottom mt-30 enter-otp-structure hidden-desktop-screen">
                    <div className="col-md-6 col-xs-12 all-box-padding-right">
                      <div className="form-group">
                        <label className="title-bg inp-label">Enter OTP TO LIFEASSURED</label>
                        <input
                          className="form-control"
                          style={isIE ? { lineHeight: 1 } : {}}
                          name="otp"
                          type="text"
                          autoComplete="new-password"
                          placeholder="XXXXXX"
                          onChange={handleInputChange}
                          maxLength={6}
                          value={otpEntered}
                        />
                        {/* {showResendOtpButton ?
                          <div className="resend-otp">
                            <a tabIndex="0" onKeyPress={(event) => { handleEnter(event) }} onClick={generateOtp}>RESEND OTP</a>{" "}
                            <span className="fa fa-angle-right"></span>
                          </div>
                          : (otpSent &&
                            <div className="resend-otp">
                              <span className="fa">RESEND OTP In {resetOtpCounter} seconds</span>
                            </div>
                          )
                        } */}
                      </div>
                    </div>
                  </div>}

                { (corpDiscOpt === "N") &&
                <div className="iselect-mg-bottom mt-30 enter-otp-structure hidden-desktop-screen" >
                  <div className="col-lg-6 col-md-12 col-12 all-box-padding-right">
                    <div className="form-group">
                      <label className="title-bg inp-label">Enter OTP</label>
                      <input
                        className="form-control"
                        style={ isIE ? {lineHeight: 1} : {} }
                        name="otp"
                        type="text"
                        autoComplete="new-password"
                        placeholder="XXXXXX"
                        onChange={handleInputChange}
                        maxLength={6}
                        value={otpEntered}
                      />
                      {showResendOtpButton ? 
                      <div className="resend-otp">
                        <a  tabIndex="0" onKeyPress={(event)=>{handleEnter(event,"resend")}} onClick={() => generateOtpCorpDiscount("resend")}>RESEND OTP</a>{" "}
                        <span className="fa fa-angle-right"></span>
                      </div>
                      : (otpSent && 
                        <div className="resend-otp">
                          <span className="fa">RESEND OTP In {resetOtpCounter} seconds</span>
                        </div>
                        )
                      }
                    </div>
                  </div>
                </div>
                }
                { (corpDiscOpt === "Y" && corpOtpReceive === false) &&
                <div className="iselect-mg-bottom mt-30 enter-otp-structure hidden-desktop-screen" style={{display:"flex", justifyContent:"center"}}>
                  <div className="col-lg-6 col-md-12 col-12 all-box-padding-right">
                    <div className="form-group">
                      <label className="title-bg inp-label">Enter OTP TO LIFEASSURED </label>
                      <input
                        className="form-control"
                        style={ isIE ? {lineHeight: 1} : {} }
                        name="otp"
                        type="text"
                        autoComplete="new-password"
                        placeholder="XXXXXX"
                        onChange={handleInputChange}
                        maxLength={6}
                        value={otpEntered}
                      />
                      {showResendOtpButton ? 
                      <div className="resend-otp">
                        <a  tabIndex="0" onKeyPress={(event)=>{handleEnter(event,"resend")}} onClick={() => generateOtpCorpDiscount("resend")}>RESEND OTP</a>{" "}
                        <span className="fa fa-angle-right"></span>
                      </div>
                      : (otpSent && 
                        <div className="resend-otp">
                          <span className="fa">RESEND OTP In {resetOtpCounter} seconds</span>
                        </div>
                        )
                      }
                    </div>
                  </div>
                </div>
                }

                <div className="iselect-mg-bottom mt-50 medical-btn hidden-desktop-screen">
                  <div className="col-md-12">
                    <div className="but-center text-center">
                      {/* <div className="submit-btn cen">
                        {" "}
                        <a>Previous</a>{" "}
                      </div> */}
                      <div className="previous-btn cen" onKeyPress={(event) => { handleEnterAccept(event) }} tabIndex="0"
                        // style={{backgroundColor: `${otpEntered?.length === 6 ? (journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25") : "grey"}`}}
                        style={{ padding: "0px" }}
                      > {/*var(--lumiq-tertiary);*/}

                        <button
                          type="submit"
                          value="accept"
                          style={{
                            backgroundColor: "transparent",

                            padding: "14px 40px",
                            border: "none",
                            color: "#fff",
                            // height: "25px",
                            borderRadius: "10px",
                            width: "100%",
                            fontSize: "16px"
                          }}
                          // disabled={otpEntered?.length !== 6}
                          onClick={handleAccept}
                        >
                          Accept
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* body Section */}
        {/* mobile view otp screen */}
        <div style={{ marginTop: "-70px" }} className="date-and-place-structure dpb">
          <div className="col-md-12" style={{ top: "18px" }} >
            <p style={{
              marginLeft: "20px"
            }}>

              <span>Date: </span>{getDateInFormat(Math.floor((new Date().getTime()) / 1000))}
            </p>
          </div>
          <div className="col-md-12" style={{
            padding: "8px",
            paddingTop: "0px"
          }}>
            <div className="iselect-mg-bottom mt-30 enter-otp-structure">
              <div className="col-md-6 col-xs-12 all-box-padding-right">
                <div className="form-group">
                  <label style={{ zIndex: "1" }} className="title-bg inp-label">Place</label>
                  <input className="form-control" name={+Date.now()}
                    style={isIE ? { lineHeight: 1 } : {}}
                    type="text" placeholder="Enter place" value={placeEntered} autoComplete="new-password" onChange={handlePlaceChange} />
                  {showError && showError.place ? (<span style={{ color: "red" }} className="input-error remove-font-weight" >{placeError}</span>) : (<div></div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="otp-box" className={`otp-mobile-view-structure secondf ${mobileProceed ? "hidden" : ""} `}>
          <div className="mobile-otp-icon" style={{ height: "35px" }}>
            <img src="images/mobile-otp.png" />
          </div>
          {isLaAndPropSame === "N" &&
            <div className="generate-otp-structure">
              <div className="previous-btn cen button" tabIndex="0" onKeyPress={(event) => { handleEnter2(event) }} style={{ padding: "0px", transition: "none", backgroundColor: `${agreeTodeclaration ? (journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25") : "grey"}` }}> {/*var(--lumiq-tertiary);*/}
                {!otpSent2 &&
                  <button className="white1" onClick={generateOtp2} style={{
                    border: "none", color: "white", borderRadius: "1rem",
                    outline: "none", width: "auto", fontSize: "16px", padding: "6px 19px", backgroundColor: `${agreeTodeclaration ? (journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25") : "grey"}`
                  }} disabled={!agreeTodeclaration}> {/*var(--lumiq-tertiary);*/}
                    Generate OTP
                  </button>
                }
              </div>
              {otpSent2 &&
                <p className="sent-otp">

                  OTP has been sent to your registered mobile number and email id
                </p>
              }
            </div>}
          <div className="clearfix"></div>
          {isLaAndPropSame === "N" &&
            <div className="iselect-mg-bottom mt-30 enter-otp-structure">
              <div className="col-md-6 col-xs-12 all-box-padding-right">
                <div className="form-group form-group-PRO">
                  <label className="title-bg">Enter OTP TO PROPOSER</label>
                  <input
                    className="form-control"
                    style={isIE ? { lineHeight: 1 } : {}}
                    name="otp"
                    type="text"
                    autoComplete="new-password"
                    placeholder="XXXXXX"
                    onChange={handleInputChange2}
                    maxLength={6}
                    value={otpEntered2}
                  />
                  {showResendOtpButton2 ?
                    <div style={{ cursor: "pointer" }} className="resend-otp">
                      <a tabIndex="0" onKeyPress={(event) => { handleEnter2(event) }} onClick={generateOtp2}>RESEND OTP</a>{" "}
                      <span className="fa fa-angle-right"></span>
                    </div>
                    : (otpSent2 &&
                      <div className="resend-otp">
                        <span className="fa">RESEND OTP In {resetOtpCounter2} seconds</span>
                      </div>
                    )
                  }
                </div>
              </div>
            </div>}
          {!isLaMinor &&
            <div className="generate-otp-structure">
              <div className="previous-btn cen button" tabIndex="0" onKeyPress={(event) => { handleEnter(event) }} style={{ padding: "0px", transition: "none", backgroundColor: `${agreeTodeclaration ? (journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25") : "grey"}` }}> {/*var(--lumiq-tertiary);*/}
                {!otpSent &&
                  <button className="white1" onClick={generateOtp} style={{
                    border: "none", color: "white", borderRadius: "1rem",
                    outline: "none", width: "auto", fontSize: "16px", padding: "6px 19px", backgroundColor: `${agreeTodeclaration ? (journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25") : "grey"}`
                  }} disabled={!agreeTodeclaration}> {/*var(--lumiq-tertiary);*/}
                    Generate OTP
                  </button>
                }
              </div>
              {otpSent &&
                <p className="sent-otp">

                  OTP has been sent to your registered mobile number and email id
                </p>
              }
            </div>}
          <div className="clearfix"></div>
          {!isLaMinor &&
            <div className="iselect-mg-bottom mt-30 enter-otp-structure">
              <div className="col-md-6 col-xs-12 all-box-padding-right">
                <div className="form-group form-group-LA">
                  <label className="title-bg">Enter OTP TO LIFEASSURED</label>
                  <input
                    className="form-control"
                    style={isIE ? { lineHeight: 1 } : {}}
                    name="otp"
                    type="text"
                    autoComplete="new-password"
                    placeholder="XXXXXX"
                    onChange={handleInputChange}
                    maxLength={6}
                    value={otpEntered}
                  />
                  {showResendOtpButton ?
                    <div style={{ cursor: "pointer" }} className="resend-otp">
                      <a tabIndex="0" onKeyPress={(event) => { handleEnter(event) }} onClick={generateOtp}>RESEND OTP</a>{" "}
                      <span className="fa fa-angle-right"></span>
                    </div>
                    : (otpSent &&
                      <div className="resend-otp">
                        <span className="fa">RESEND OTP In {resetOtpCounter} seconds</span>
                      </div>
                    )
                  }
                </div>
              </div>
            </div>}
        </div>

        {/* mobile view otp screen */}

        {/* <!--mobile view button--> */}
        <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1">
          <div className="iselect-mg-bottom">
            <div className="col-md-12">
              <div className="but-center text-center">
                <div className="previous-btn cen">
                  <a>
                    {" "}
                    <button
                      onClick={handleAccept}
                      // disabled={otpEntered?.length !== 6}
                      type="submit"
                      value="button1"
                      style={{ backgroundColor: "transparent", padding: "0px 10px", border: "none", color: "#fff" }}
                    >
                      Proceed
                    </button>{" "}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--mobile view button-->  */}
      </form>
    </>
  )
}
